import type { IdentificationDocumentStateEnum } from "web_myplann/Infrastructure/Api/Api";

export const ClientKeys = {
	all: ["client"] as const,
	get identificationDocumentsAll() {
		return [...this.all, "identification-documents"] as const;
	},
	identificationDocuments: (state: IdentificationDocumentStateEnum) =>
		[...ClientKeys.identificationDocumentsAll, state] as const,
};
